import { useFetch } from '@/shared/hooks/useFetch';
import { queryKeys } from '@/shared/api/queryKeys';
import { apiStaffListGet } from '@/entities/staff/modules/api/staff';
import type { ApiStaffListParams } from '@/shared/types/api/staff';

export const useStaffList = (params: ApiStaffListParams) =>
  useFetch({
    api: () => apiStaffListGet(params),
    keywords: queryKeys.staff.list(params),
    staleTime: 60_000,
  });
